import type React from 'react';
import { useTruncationObserver } from '@/hooks/useTruncationObserver';

export type TruncationInjectedProps = {
  isTruncated: boolean;
  truncationRef: React.RefCallback<HTMLElement>;
  checkTruncation: () => void;
};

export function withTruncation<P extends TruncationInjectedProps>(
  Component: React.ComponentType<P>
) {
  return function WithTruncation(
    props: Omit<P, keyof TruncationInjectedProps>
  ) {
    const { truncationRef, isTruncated, checkTruncation } =
      useTruncationObserver();

    return (
      <Component
        {...(props as P)}
        isTruncated={isTruncated}
        truncationRef={truncationRef}
        checkTruncation={checkTruncation}
      />
    );
  };
}
